<template>
  <div>
    <download-csv
      :class="[
        isPrimaryButton ? 'button-gemnote' : 'whitebutton-gemnote',
        isGray ? 'gray' : '',
        buttonSize,
        withDataOk
      ]"
      :disabled="data.length <= 0"
      :fields="fields"
      :labels="labels"
      :data="data"
      :name="fileName"
      type="csv"
    >
      <span :style="customStyles">{{ buttonLabel }}</span>
    </download-csv>
  </div>
</template>

<script>
export default {
  name: 'ExportToCSVButton',
  props: {
    buttonLabel: {
      type: String,
      default: 'Export Data'
    },
    buttonType: {
      type: String,
      default: 'medium'
    },
    fields: {
      type: Array,
      required: false
    },
    labels: {
      type: Object,
      required: false
    },
    data: {
      type: Array,
      required: true
    },
    fileName: {
      type: String,
      default: 'data.csv'
    },
    isPrimaryButton: {
      type: Boolean,
      default: true
    },
    customStyles: {
      type: String,
      default: ''
    },
    isGray: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonSize() {
      switch (this.buttonType) {
        case 'small':
          return 'button-gemnote--small'
        case 'large':
          return 'button-gemnote--large'
        case 'tiny':
          return 'button-gemnote--tiny'
        default:
          return 'button-gemnote--medium'
      }
    },
    withDataOk() {
      return this.data.length
        ? ''
        : this.isPrimaryButton
        ? 'button-gemnote--disabled'
        : 'white-button-gemnote--disabled'
    }
  }
}
</script>

<style lang="scss" scoped>
.white-button-gemnote--disabled {
  opacity: 0.5;
}

.button-gemnote--small {
  padding: 0 1.25rem;
  height: 2.5rem;
}
</style>
